<template>
  <div class="batteryConsignRecordBatterySnap">
    <div class="main-title">
      <p @click="toList">电池寄存记录</p>
      <p @click="toDetail">>完成进度</p>
      <p>>设备快照</p>
    </div>
    <div class="main-body">
      <div class="list">
        <div class="name-label">设备编号：</div>
        <div class="value-label">{{ primaryDeviceNo }}</div>
      </div>
      <div class="list">
        <span>时间：</span>
        <el-date-picker
          v-model="startTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          placeholder="开始日期">
        </el-date-picker>
        --
        <el-date-picker
          v-model="endTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          placeholder="结束日期">
        </el-date-picker>
        <span class="ml10">端口编号：</span>
        <el-select
          size="mini"
          v-model="chargePortSeqNo">
          <el-option
            v-for="(item,key) in portList"
            :key="item.port"
            :label="item.label"
            :value="item.port">
          </el-option>
        </el-select>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th>设备快照编号</th>
          <th>接收时间</th>
          <th>端口编号</th>
          <th>端口状态</th>
          <th>端口电流</th>
          <th>端口电压</th>
          <th>端口服务状态</th>
          <th>柜门状态</th>
          <th>二维码编号</th>
          <th>电池电量</th>
          <th>电池电流</th>
          <th>健康状态</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.number }}</td>
          <td>{{ item.createTime }}</td>
          <td>{{ item.chargePortSeqNo ? item.chargePortSeqNo + "号" : "--" }}</td>
          <td>{{ item.status }}</td>
          <td>{{ item.electricCurrent }}</td>
          <td>{{ item.electricVoltage }}</td>
          <td>{{ portServiceStatusMap[item.serviceStatus] }}</td>
          <td>{{ item.doorStatus }}</td>
          <td>{{ item.batteryQrcode }}</td>
          <td>{{ item.batterySoc }}</td>
          <td>{{ item.batteryElectricCurrent }}</td>
          <td>{{ item.batterySoh }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="12">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ pageIndex }}页，当前页{{ dataList.length }}条，共{{ total }}条</div>
        <div class="page-count">跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">跳转</div>
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
    <el-dialog title="单体电压" width="30%" :visible.sync="dialogVisible">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        height="250">
        <el-table-column
          prop="cellSeqNo"
          label="单体电压编号"
          width="250">
        </el-table-column>
        <el-table-column
          prop="electricVoltage"
          label="电压"
          width="250">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false">确定</el-button>
          </span>
    </el-dialog>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'batteryConsignRecordBatterySnap',
  data() {
    return {
      title: '',
      consignType: '',
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      total: '',
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dialogVisible: false,
      recordNo: '',
      startTime: '',
      endTime: '',
      chargePortSeqNo: '',
      portList: [],
      primaryDeviceNo: '',
      portServiceStatusMap: {
        '-1': '未展示',
        '0': '停用',
        '1': '启用',
      },
      dataList: [],
      tableData: [],
      loading: false,
      searchCondition: '',
      deviceName: '',
      begin: 0
    }
  },
  mounted() {
    if (this.$route.query.recordNo) {
      this.recordNo = this.$route.query.recordNo;
      this.getQueryTime();
    }
    if (this.$route.query.type) {
      this.consignType = this.$route.query.type;
    }
    if (this.$route.query.primaryDeviceNo) {
      this.primaryDeviceNo = this.$route.query.primaryDeviceNo;
    }
    if (this.$route.query.chargePortSeq) {
      var portList = [{port: "", name: ""}];
      portList[0].label = "入口:" + this.$route.query.chargePortSeq + "号";
      portList[0].port = this.$route.query.inPort;
      this.portList = portList;
      this.chargePortSeqNo = this.$route.query.chargePortSeq;
    }
  },
  methods: {
    getQueryTime() {
      let self = this;
      let params = {
        recordNo: this.recordNo
      };
      this.$http.post('/managementPlatform/electricity/getBatteryConsignRecordSnapShotTimeRange', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.startTime = res.mdata.beginTime;
        self.endTime = res.mdata.endTime;
        self.querySnapshot();
      }).catch(function (response) {
        console.log(response);
      });
    },
    querySnapshot() {
      let self = this;
      let params = {
        primaryDeviceNo: this.primaryDeviceNo,
        chargePortSeqNo: this.chargePortSeqNo,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        beginTime: this.startTime,
        endTime: this.endTime
      };
      this.$http.post('/managementPlatform/electricity/querySnapshot', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
        self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
        self.pageIndex = self.page;
        self.total = res.mdata.total;
        self.totalPage = Math.floor((parseInt(res.mdata.total) - 1) / self.pageSize) + 1;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.querySnapshot();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.querySnapshot();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.querySnapshot();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.querySnapshot();
    },
    toList() {
      this.$router.push("/managePage/batteryConsignRecord");
    },
    toDetail() {
      this.$router.push("/managePage/batteryConsignRecord?recordNo=" + this.recordNo + "&type=" + this.consignType);
    }
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/batteryConsignRecordBatterySnap.vue